import { useEffect, useRef } from "react";

const isProd = process.env.NODE_ENV === "production";

function useDevToolsGuard({ enabled = isProd, thresholdMs = 100, confirmTicks = 3 } = {}) {
  const overlayRef = useRef(null);
  const strikeCount = useRef(0);

  useEffect(() => {
    if (!enabled) return;


    function checkDebuggerTiming() {
      const start = performance.now();
      debugger;
      return performance.now() - start;
    }

    function checkWindowSize() {
      const threshold = 160;
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      return widthDiff > threshold || heightDiff > threshold;
    }

    function showOverlay() {
      if (overlayRef.current) return;
      const el = document.createElement("div");
      el.id = "__devtools_guard_overlay";
      el.style.cssText = `
        position: fixed; inset: 0; z-index: 999999;
        background: rgba(10,10,10,0.97); color: #fff;
        display: flex; align-items: center; justify-content: center;
        font-family: sans-serif; font-size: 18px; text-align: center;
        padding: 24px;
      `;
      el.textContent = "Please close developer tools to continue using this page.";
      document.body.appendChild(el);
      overlayRef.current = el;
    }

    function hideOverlay() {
      if (overlayRef.current) {
        overlayRef.current.remove();
        overlayRef.current = null;
      }
    }

    const intervalId = setInterval(() => {
      const timingFlag = checkDebuggerTiming() > thresholdMs;
      const sizeFlag = checkWindowSize();
      const suspected = timingFlag || sizeFlag;

      strikeCount.current = suspected
        ? Math.min(strikeCount.current + 1, confirmTicks)
        : 0;

      if (strikeCount.current >= confirmTicks) {
        showOverlay();
      } else {
        hideOverlay();
      }
    }, 500);

    return () => {
      clearInterval(intervalId);
      hideOverlay();
    };
  }, [enabled, thresholdMs, confirmTicks]);
}

export default useDevToolsGuard;